
<template>
  <div class="main-content" id="panel">
    <!-- Header -->
    <!-- <Header /> -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2>HIB vs IDC</h2>
            </div>
            <div class="col-lg-6 col-5 text-right"></div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6">
      <div class="row justify-content-md-center upload">
        <div class="col-xl-6">
          <div class="card">
            <div class="card-header bg-transparent">
              <div class="row align-items-center">
                <div class="col">
                  <h3>HIB vs IDC</h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <!-- Chart -->
              <div class="chart">
                <span class="round"><img src="../../assets/img/vector/download.png" alt /></span>
                <h4>
                  
                </h4>
                <p></p>
                <button type="button" @click="exportHib()" class="btn btn-primary rounded ml-1">
                      <i v-if="!exporting" class="fas fa-download"></i> 
                      <i v-if="exporting" class="fa fa-spinner fa-spin"></i>
                      <span v-if="!exporting">EXPORT</span>
                      <span v-if="exporting">EXPORTING...</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
    </div>
  </div>
</template>
<script>
    import authService from "@/authService"
    import config from "@/config";
    export default {
        name: 'tmcExceltopdf',
        components :{
            
        },
        data() {
            return {
                exporting : false
            };
        },
        methods: {
            exportHib(){
                this.exporting = true;
                const auth = {
                    headers: {'org-token' : authService.getOrgToken() }
                };
                this.$http
                    .get(
                    config.baseUrlBidSide +
                        "/excel/report-hib-idc",
                        auth
                    )
                    .then(response => {
                    this.exporting = false;
                    if(response.data){
                        window.open(response.data, "_blank");
                    }

                    })
                    .catch(e => {
                    console.log(e);
                    this.exporting = false;
                    });
            }
        },
        created: function() {
        }
    };
  </script> 